import { alpha } from '@mui/material';
export const getUserRegistrationStyles = (previewLayout) => {
    const isPreviewMobile = previewLayout === 'mobile';
    const isPreviewTablet = previewLayout === 'tablet';
    const isPreviewCompact = isPreviewMobile || isPreviewTablet;
    return {
        root: {
            flex: 1,
            width: '100%',
            maxWidth: 720,
            alignSelf: 'center',
            minHeight: 0,
            mx: 'auto',
            px: isPreviewMobile ? 1 : isPreviewTablet ? 1.25 : { xs: 1, sm: 1.5, md: 2 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            overflowY: 'auto'
        },
        card: {
            background: '#FFFFFF',
            borderRadius: '16px',
            padding: isPreviewMobile ? 2 : isPreviewTablet ? 2.5 : { xs: 2, sm: 2.5, md: 3, lg: 4 },
            width: '100%',
            display: 'flex',
            border: `1px solid ${alpha('#00244D', 0.2)}`,
            boxShadow: '0px 40px 56px 0px #00000014, 0px 16px 40px 0px #0000000F, 0px 4px 8px 0px #0000000A',
            flexDirection: 'column',
            alignItems: 'stretch'
        },
        content: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: isPreviewCompact ? 1 : 1.5
        },
        welcomeMessage: {
            width: '100%',
            padding: 0,
            '& img': {
                maxWidth: '100%',
                height: 'auto',
                display: 'block',
                margin: '8px 0'
            },
            '& p': {
                margin: 0,
                fontFamily: 'SuisseIntl',
                color: '#000000'
            },
            '& .ql-size-small': {
                fontSize: '12px !important'
            },
            '& .ql-size-large': {
                fontSize: '24px !important'
            },
            '& .ql-size-huge': {
                fontSize: '32px !important'
            }
        },
        welcomeLabel: {
            color: '#637381',
            fontSize: isPreviewCompact ? '0.8125rem' : { xs: '0.875rem', sm: '1rem' }
        },
        welcomeTitle: {
            color: '#00244D',
            fontWeight: 500,
            fontSize: isPreviewMobile ? '1.5rem' : isPreviewTablet ? '1.625rem' : { xs: '1.75rem', sm: '2.25rem' },
            lineHeight: 1.2
        },
        welcomeDate: {
            color: '#00244D',
            fontWeight: 500,
            fontSize: isPreviewCompact ? '0.9375rem' : { xs: '1rem', sm: '1.125rem' }
        },
        startButton: {
            mt: isPreviewCompact ? 1.5 : 2,
            py: 1.5,
            backgroundColor: '#00244D',
            color: '#FFFFFF',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
                backgroundColor: '#001a38'
            }
        }
    };
};
export const userLoginStyles = getUserRegistrationStyles();
